// extracted by mini-css-extract-plugin
export default {"avatarLoader":"avatarLoader_avatarLoader__yZhfH","avatarPreview":"avatarLoader_avatarPreview__cr5E5"};